// GaussIQ Icon System — the master SVG sprite. Every <symbol> here is a 24x24
// glyph drawn with the system's signature rule: a filled node dot appears only
// where a shape has a genuine vertex (roof peak, star point, pin tip, keyhole),
// matching the triangulation points in the GaussIQ logo mark. Mounted once at
// the app root; every <Icon name="..."/> instance references a symbol by id.
const SPRITE_MARKUP = `
<defs>
  <symbol id="badge-blob" viewBox="0 0 100 100">
    <path d="M50,12 C66,11 81,20 86,36 C91,52 87,68 74,79 C63,88 47,90 33,83 C18,76 10,60 13,44 C16,28 27,15 43,12 C45.3,11.5 47.7,11.7 50,12 Z"/>
  </symbol>

  <!-- ===== Navigation ===== -->
  <symbol id="i-home" viewBox="0 0 24 24">
    <path d="M4,11.5 L12,4.5 L20,11.5"/>
    <path d="M6.5,10 V19 a1,1 0 0 0 1,1 H16.5 a1,1 0 0 0 1,-1 V10"/>
    <path d="M10,20 V14.5 H14 V20"/>
    <circle cx="12" cy="4.5" r="1.15" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-skills" viewBox="0 0 24 24">
    <polygon points="12,2 15.1,8.3 22,9.3 17,14.1 18.2,21 12,17.8 5.8,21 7,14.1 2,9.3 8.9,8.3"/>
    <circle cx="12" cy="2" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="22" cy="9.3" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="18.2" cy="21" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="5.8" cy="21" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="2" cy="9.3" r="1.1" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-people" viewBox="0 0 24 24">
    <circle cx="9" cy="9" r="3"/>
    <path d="M3.5,19 a5.5,5 0 0 1 11,0"/>
    <circle cx="17" cy="9.2" r="2.4"/>
    <path d="M15.2,14.2 a4.6,4.2 0 0 1 5.3,4.8"/>
  </symbol>
  <symbol id="i-cases" viewBox="0 0 24 24">
    <path d="M6.5,3.5 h7 l4,4 v13 a1,1 0 0 1 -1,1 h-10 a1,1 0 0 1 -1,-1 v-16 a1,1 0 0 1 1,-1 z"/>
    <polyline points="13.5,3.5 13.5,7.5 17.5,7.5"/>
    <line x1="8" y1="13" x2="16" y2="13"/>
    <line x1="8" y1="16.5" x2="14.5" y2="16.5"/>
  </symbol>
  <symbol id="i-knowledge" viewBox="0 0 24 24">
    <path d="M3.5,5 L11.5,6.5 V19 L3.5,17.5 Z"/>
    <path d="M20.5,5 L12.5,6.5 V19 L20.5,17.5 Z"/>
    <circle cx="12" cy="19" r="1.1" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-connect" viewBox="0 0 24 24">
    <line x1="7.8" y1="11" x2="16.2" y2="6"/>
    <line x1="7.8" y1="13" x2="16.2" y2="18"/>
    <circle cx="18" cy="5" r="1.7" fill="currentColor" stroke="none"/>
    <circle cx="6" cy="12" r="1.7" fill="currentColor" stroke="none"/>
    <circle cx="18" cy="19" r="1.7" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-settings" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="6.2"/>
    <circle cx="12" cy="12" r="2.4"/>
    <rect x="10.7" y="2.4" width="2.6" height="3.2" rx="0.7" transform="rotate(0 12 12)"/>
    <rect x="10.7" y="2.4" width="2.6" height="3.2" rx="0.7" transform="rotate(60 12 12)"/>
    <rect x="10.7" y="2.4" width="2.6" height="3.2" rx="0.7" transform="rotate(120 12 12)"/>
    <rect x="10.7" y="2.4" width="2.6" height="3.2" rx="0.7" transform="rotate(180 12 12)"/>
    <rect x="10.7" y="2.4" width="2.6" height="3.2" rx="0.7" transform="rotate(240 12 12)"/>
    <rect x="10.7" y="2.4" width="2.6" height="3.2" rx="0.7" transform="rotate(300 12 12)"/>
  </symbol>
  <symbol id="i-sidebar-collapse" viewBox="0 0 24 24">
    <rect x="3" y="3" width="18" height="18" rx="3"/>
    <line x1="9" y1="3" x2="9" y2="21"/>
  </symbol>
  <symbol id="i-sidebar-expand" viewBox="0 0 24 24">
    <polyline points="9,6 15,12 9,18"/>
  </symbol>

  <!-- ===== Actions ===== -->
  <symbol id="i-search" viewBox="0 0 24 24">
    <circle cx="10.5" cy="10.5" r="6.25"/>
    <line x1="15.3" y1="15.3" x2="20" y2="20"/>
  </symbol>
  <symbol id="i-close" viewBox="0 0 24 24">
    <line x1="6.5" y1="6.5" x2="17.5" y2="17.5"/>
    <line x1="17.5" y1="6.5" x2="6.5" y2="17.5"/>
  </symbol>
  <symbol id="i-check" viewBox="0 0 24 24"><polyline points="5,13 10,18 19,7"/></symbol>
  <symbol id="i-chevron-up" viewBox="0 0 24 24"><polyline points="5.5,14.5 12,8 18.5,14.5"/></symbol>
  <symbol id="i-chevron-down" viewBox="0 0 24 24"><polyline points="5.5,9.5 12,16 18.5,9.5"/></symbol>
  <symbol id="i-chevron-left" viewBox="0 0 24 24"><polyline points="14.5,5.5 8,12 14.5,18.5"/></symbol>
  <symbol id="i-chevron-right" viewBox="0 0 24 24"><polyline points="9.5,5.5 16,12 9.5,18.5"/></symbol>
  <symbol id="i-more" viewBox="0 0 24 24">
    <circle cx="5.5" cy="12" r="1.5" fill="currentColor" stroke="none"/>
    <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"/>
    <circle cx="18.5" cy="12" r="1.5" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-menu" viewBox="0 0 24 24">
    <line x1="4.5" y1="7" x2="19.5" y2="7"/>
    <line x1="4.5" y1="12" x2="19.5" y2="12"/>
    <line x1="4.5" y1="17" x2="19.5" y2="17"/>
  </symbol>
  <symbol id="i-plus" viewBox="0 0 24 24">
    <line x1="12" y1="5" x2="12" y2="19"/>
    <line x1="5" y1="12" x2="19" y2="12"/>
  </symbol>
  <symbol id="i-filter" viewBox="0 0 24 24"><path d="M4,5 H20 L14,12.5 V19.5 L10,21.5 V12.5 Z"/></symbol>
  <symbol id="i-edit" viewBox="0 0 24 24">
    <path d="M5,19 L5.8,15 L15.5,5.3 a1.8,1.8 0 0 1 2.5,0 l0.7,0.7 a1.8,1.8 0 0 1 0,2.5 L9,18.2 Z"/>
    <line x1="14" y1="6.8" x2="17.2" y2="10"/>
  </symbol>
  <symbol id="i-trash" viewBox="0 0 24 24">
    <line x1="5" y1="7" x2="19" y2="7"/>
    <path d="M9,7 v-1.5 a1,1 0 0 1 1,-1 h4 a1,1 0 0 1 1,1 v1.5"/>
    <path d="M7,7 l1,12.5 a1.5,1.5 0 0 0 1.5,1.5 h5 a1.5,1.5 0 0 0 1.5,-1.5 l1,-12.5"/>
    <line x1="12" y1="10.5" x2="12" y2="16.5"/>
  </symbol>
  <symbol id="i-refresh" viewBox="0 0 24 24">
    <path d="M18.5,7.5 A7.5,7.5 0 1 1 16.8,4.9"/>
    <polyline points="19.2,3.2 19.2,7.5 14.9,7.5"/>
  </symbol>
  <symbol id="i-upload" viewBox="0 0 24 24">
    <polyline points="8,10 12,6 16,10"/>
    <line x1="12" y1="6" x2="12" y2="16"/>
    <path d="M5,17.5 v2 a1.5,1.5 0 0 0 1.5,1.5 h11 a1.5,1.5 0 0 0 1.5,-1.5 v-2"/>
  </symbol>
  <symbol id="i-download" viewBox="0 0 24 24">
    <polyline points="8,10.5 12,14.5 16,10.5"/>
    <line x1="12" y1="5" x2="12" y2="14.5"/>
    <path d="M5,17.5 v2 a1.5,1.5 0 0 0 1.5,1.5 h11 a1.5,1.5 0 0 0 1.5,-1.5 v-2"/>
  </symbol>
  <symbol id="i-link" viewBox="0 0 24 24">
    <rect x="2.5" y="9.5" width="9" height="5" rx="2.5" transform="rotate(45 12 12)"/>
    <rect x="12.5" y="9.5" width="9" height="5" rx="2.5" transform="rotate(45 12 12)"/>
  </symbol>
  <symbol id="i-lock" viewBox="0 0 24 24">
    <rect x="5.5" y="11" width="13" height="9" rx="2"/>
    <path d="M8,11 V8 a4,4 0 0 1 8,0 V11"/>
    <circle cx="12" cy="15" r="1.3" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-lock-open" viewBox="0 0 24 24">
    <rect x="5.5" y="11" width="13" height="9" rx="2"/>
    <path d="M8,11 V7.5 a4,4 0 0 1 7,-2.6"/>
    <circle cx="12" cy="15" r="1.3" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-desktop" viewBox="0 0 24 24">
    <rect x="3" y="4" width="18" height="12.5" rx="1.8"/>
    <line x1="12" y1="16.5" x2="12" y2="20"/>
    <line x1="8.5" y1="20" x2="15.5" y2="20"/>
  </symbol>
  <symbol id="i-logout" viewBox="0 0 24 24">
    <path d="M9,4 H6 a2,2 0 0 0 -2,2 V18 a2,2 0 0 0 2,2 H9"/>
    <line x1="10.5" y1="12" x2="20.5" y2="12"/>
    <polyline points="17,8.5 20.5,12 17,15.5"/>
  </symbol>
  <symbol id="i-arrow-left" viewBox="0 0 24 24">
    <line x1="19" y1="12" x2="5" y2="12"/>
    <polyline points="11,6 5,12 11,18"/>
  </symbol>
  <symbol id="i-arrow-right" viewBox="0 0 24 24">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="13,6 19,12 13,18"/>
  </symbol>

  <!-- ===== Status ===== -->
  <symbol id="i-eye" viewBox="0 0 24 24">
    <path d="M3,12 C3,12 6.5,6 12,6 C17.5,6 21,12 21,12 C21,12 17.5,18 12,18 C6.5,18 3,12 3,12 Z"/>
    <circle cx="12" cy="12" r="3"/>
  </symbol>
  <symbol id="i-eye-off" viewBox="0 0 24 24">
    <path d="M3,12 C3,12 6.5,6 12,6 C17.5,6 21,12 21,12 C21,12 17.5,18 12,18 C6.5,18 3,12 3,12 Z"/>
    <circle cx="12" cy="12" r="3"/>
    <line x1="4" y1="4.5" x2="20" y2="19.5"/>
  </symbol>
  <symbol id="i-info" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8.25"/>
    <line x1="12" y1="11" x2="12" y2="16.5"/>
    <circle cx="12" cy="7.8" r="1.1" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-warning" viewBox="0 0 24 24">
    <path d="M10.3,3.9 L1.8,18 a2,2 0 0 0 1.7,3 h17 a2,2 0 0 0 1.7,-3 L13.7,3.9 a2,2 0 0 0 -3.4,0 z"/>
    <line x1="12" y1="9.3" x2="12" y2="13.3"/>
    <circle cx="12" cy="16.4" r="1.15" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-bell" viewBox="0 0 24 24">
    <path d="M7,17 V11 a5,5 0 0 1 10,0 V17"/>
    <line x1="5.5" y1="17" x2="18.5" y2="17"/>
    <path d="M10.5,19.6 a1.5,1.5 0 0 0 3,0"/>
  </symbol>
  <symbol id="i-sun" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="4.5"/>
    <line x1="12" y1="2.5" x2="12" y2="5"/>
    <line x1="12" y1="19" x2="12" y2="21.5"/>
    <line x1="4.2" y1="4.2" x2="5.9" y2="5.9"/>
    <line x1="18.1" y1="18.1" x2="19.8" y2="19.8"/>
    <line x1="2.5" y1="12" x2="5" y2="12"/>
    <line x1="19" y1="12" x2="21.5" y2="12"/>
    <line x1="4.2" y1="19.8" x2="5.9" y2="18.1"/>
    <line x1="18.1" y1="5.9" x2="19.8" y2="4.2"/>
  </symbol>
  <symbol id="i-moon" viewBox="0 0 24 24">
    <path d="M20.5,14.5 A9,9 0 1 1 9.5,3.5 A7,7 0 0 0 20.5,14.5 Z"/>
  </symbol>
  <symbol id="i-spinner" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8.25" stroke-dasharray="34 18"/>
  </symbol>
  <symbol id="i-status-neutral" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8.25"/>
    <line x1="8.5" y1="12" x2="15.5" y2="12"/>
  </symbol>

  <!-- ===== People ===== -->
  <symbol id="i-user" viewBox="0 0 24 24">
    <circle cx="12" cy="8.5" r="3.5"/>
    <path d="M5.5,20 a6.5,6 0 0 1 13,0"/>
  </symbol>
  <symbol id="i-pin" viewBox="0 0 24 24">
    <path d="M12,21 C12,21 5,14.2 5,9.5 a7,7 0 0 1 14,0 C19,14.2 12,21 12,21 Z"/>
    <circle cx="12" cy="9.5" r="2.4"/>
  </symbol>

  <!-- ===== Files & sources ===== -->
  <symbol id="i-document" viewBox="0 0 24 24">
    <path d="M6.5,3.5 h7 l4,4 v13 a1,1 0 0 1 -1,1 h-10 a1,1 0 0 1 -1,-1 v-16 a1,1 0 0 1 1,-1 z"/>
    <polyline points="13.5,3.5 13.5,7.5 17.5,7.5"/>
  </symbol>
  <symbol id="i-folder" viewBox="0 0 24 24">
    <path d="M3.5,7.5 a1.5,1.5 0 0 1 1.5,-1.5 h4.5 l2,2.5 h8 a1.5,1.5 0 0 1 1.5,1.5 v8 a1.5,1.5 0 0 1 -1.5,1.5 h-15 a1.5,1.5 0 0 1 -1.5,-1.5 z"/>
  </symbol>
  <symbol id="i-globe" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8.25"/>
    <line x1="3.75" y1="12" x2="20.25" y2="12"/>
    <path d="M12,3.75 a13,13 0 0 1 3.4,8.25 A13,13 0 0 1 12,20.25 A13,13 0 0 1 8.6,12 A13,13 0 0 1 12,3.75 z"/>
  </symbol>
  <symbol id="i-layers" viewBox="0 0 24 24">
    <polygon points="12,3 21,8 12,13 3,8"/>
    <polyline points="3,12.5 12,17.5 21,12.5"/>
    <polyline points="3,17 12,22 21,17"/>
  </symbol>
  <symbol id="i-database" viewBox="0 0 24 24">
    <ellipse cx="12" cy="6.5" rx="7" ry="2.75"/>
    <path d="M5,6.5 v11 a7,2.75 0 0 0 14,0 v-11"/>
    <path d="M5,12 a7,2.75 0 0 0 14,0"/>
  </symbol>

  <!-- ===== Metrics ===== -->
  <symbol id="i-brain" viewBox="0 0 24 24">
    <path d="M12,5 a3,3 0 0 0 -5.6,-1.5 A2.5,2.5 0 0 0 4,6.5 A2.5,2.5 0 0 0 3,12 a2.5,2.5 0 0 0 1.5,4.5 A2.5,2.5 0 0 0 9,19 a3,3 0 0 0 3,-1 z"/>
    <path d="M12,5 a3,3 0 0 1 5.6,-1.5 A2.5,2.5 0 0 1 20,6.5 A2.5,2.5 0 0 1 21,12 a2.5,2.5 0 0 1 -1.5,4.5 A2.5,2.5 0 0 1 15,19 a3,3 0 0 1 -3,-1 z"/>
    <line x1="12" y1="5" x2="12" y2="19"/>
  </symbol>
  <symbol id="i-target" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8.25"/>
    <circle cx="12" cy="12" r="5"/>
    <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-clock" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8.25"/>
    <polyline points="12,7.5 12,12 15.5,14"/>
  </symbol>
  <symbol id="i-shuffle" viewBox="0 0 24 24">
    <polyline points="15.5,4 20,4 20,8.5"/>
    <line x1="4.5" y1="19.5" x2="20" y2="4"/>
    <polyline points="20,15.5 20,20 15.5,20"/>
    <line x1="14.5" y1="14.5" x2="20" y2="20"/>
    <line x1="4.5" y1="4.5" x2="9" y2="9"/>
  </symbol>
  <symbol id="i-check-square" viewBox="0 0 24 24">
    <polyline points="9,11.5 11.5,14 19.5,6.5"/>
    <path d="M20.5,12 v6.5 a2,2 0 0 1 -2,2 H5.5 a2,2 0 0 1 -2,-2 V6.5 a2,2 0 0 1 2,-2 H16"/>
  </symbol>
  <symbol id="i-trending-up" viewBox="0 0 24 24">
    <polyline points="22.5,6.5 13.5,15.5 8.5,10.5 2,17.5"/>
    <polyline points="16.5,6.5 22.5,6.5 22.5,12"/>
  </symbol>
  <symbol id="i-insight" viewBox="0 0 24 24">
    <path d="M12,2.5 L13.6,9.9 L21.5,12 L13.6,14.1 L12,21.5 L10.4,14.1 L2.5,12 L10.4,9.9 Z" fill="currentColor" stroke="none"/>
    <path d="M18.5,15 L19.2,16.8 L21,17.5 L19.2,18.2 L18.5,20 L17.8,18.2 L16,17.5 L17.8,16.8 Z" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-snowflake" viewBox="0 0 24 24">
    <line x1="12" y1="2" x2="12" y2="22"/>
    <line x1="4.2" y1="7" x2="19.8" y2="17"/>
    <line x1="19.8" y1="7" x2="4.2" y2="17"/>
    <polyline points="9,4.5 12,2 15,4.5"/>
    <polyline points="9,19.5 12,22 15,19.5"/>
    <circle cx="12" cy="2" r="1" fill="currentColor" stroke="none"/>
    <circle cx="12" cy="22" r="1" fill="currentColor" stroke="none"/>
    <circle cx="4.2" cy="7" r="1" fill="currentColor" stroke="none"/>
    <circle cx="19.8" cy="17" r="1" fill="currentColor" stroke="none"/>
    <circle cx="19.8" cy="7" r="1" fill="currentColor" stroke="none"/>
    <circle cx="4.2" cy="17" r="1" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-bars-stacked" viewBox="0 0 24 24">
    <line x1="4" y1="6" x2="20" y2="6"/>
    <line x1="4" y1="12" x2="15" y2="12"/>
    <line x1="4" y1="18" x2="11" y2="18"/>
  </symbol>
  <symbol id="i-analytics" viewBox="0 0 24 24">
    <rect x="5" y="13" width="3.5" height="7" rx="0.9"/>
    <rect x="10.25" y="8.5" width="3.5" height="11.5" rx="0.9"/>
    <rect x="15.5" y="4.5" width="3.5" height="15.5" rx="0.9"/>
  </symbol>
  <symbol id="i-arrow-up" viewBox="0 0 24 24">
    <line x1="12" y1="19.5" x2="12" y2="5"/>
    <polyline points="6,11 12,5 18,11"/>
  </symbol>
  <symbol id="i-arrow-down" viewBox="0 0 24 24">
    <line x1="12" y1="4.5" x2="12" y2="19"/>
    <polyline points="6,13 12,19 18,13"/>
  </symbol>
  <symbol id="i-hexagon-nodes" viewBox="0 0 24 24">
    <polygon points="12,2 20.5,7 20.5,17 12,22 3.5,17 3.5,7"/>
    <line x1="12" y1="8" x2="8" y2="11"/>
    <line x1="12" y1="8" x2="16" y2="11"/>
    <line x1="8" y1="11" x2="10" y2="15"/>
    <line x1="16" y1="11" x2="14" y2="15"/>
    <circle cx="12" cy="2" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="20.5" cy="7" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="20.5" cy="17" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="12" cy="22" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="3.5" cy="17" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="3.5" cy="7" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="12" cy="8" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="8" cy="11" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="16" cy="11" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="10" cy="15" r="1.1" fill="currentColor" stroke="none"/>
    <circle cx="14" cy="15" r="1.1" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-fallback" viewBox="0 0 24 24">
    <line x1="6" y1="19" x2="6" y2="13"/>
    <line x1="12" y1="19" x2="12" y2="7"/>
    <line x1="18" y1="19" x2="18" y2="10"/>
  </symbol>

  <!-- ===== Case detail ===== -->
  <symbol id="i-complexity" viewBox="0 0 24 24">
    <polyline points="7,17 12,13 17,17"/>
    <polyline points="7,12.5 12,8.5 17,12.5"/>
    <polyline points="7,8 12,4 17,8"/>
    <circle cx="12" cy="4" r="1.1" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-tag" viewBox="0 0 24 24">
    <path d="M20.5,13.4 L13.4,20.5 a2,2 0 0 1 -2.8,0 L2.5,12.4 V3.5 a1,1 0 0 1 1,-1 h8.9 L20.5,10.6 a2,2 0 0 1 0,2.8 Z"/>
    <circle cx="7.2" cy="7.2" r="1.3" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-thumb" viewBox="0 0 24 24">
    <path d="M7,11 V21 H4.5 a1,1 0 0 1 -1,-1 V12 a1,1 0 0 1 1,-1 Z"/>
    <path d="M7,11 L10.5,3.5 a1.8,1.8 0 0 1 3.4,1.1 L12.8,9 H18.5 a2,2 0 0 1 1.95,2.4 L19,19.5 a2,2 0 0 1 -2,1.6 H9 a2,2 0 0 1 -2,-2 Z"/>
  </symbol>
  <symbol id="i-friction" viewBox="0 0 24 24">
    <rect x="3" y="8" width="5.5" height="8" rx="1.2"/>
    <rect x="15.5" y="8" width="5.5" height="8" rx="1.2"/>
    <polyline points="8.5,9.5 12.5,12 9.5,13.5 15.5,15.5"/>
    <circle cx="12.5" cy="12" r="1.1" fill="currentColor" stroke="none"/>
  </symbol>

  <!-- ===== Misc ===== -->
  <symbol id="i-mail" viewBox="0 0 24 24">
    <rect x="3.5" y="6" width="17" height="12" rx="1.5"/>
    <polyline points="4,7 12,13.5 20,7"/>
  </symbol>
  <symbol id="i-calendar" viewBox="0 0 24 24">
    <rect x="3.5" y="5.5" width="17" height="15" rx="1.5"/>
    <line x1="3.5" y1="10" x2="20.5" y2="10"/>
    <line x1="8" y1="3.5" x2="8" y2="7.5"/>
    <line x1="16" y1="3.5" x2="16" y2="7.5"/>
  </symbol>

  <!-- ===== Skill types ===== -->
  <symbol id="i-skill-core" viewBox="0 0 24 24">
    <path d="M12,3 L18.5,5.5 V11 C18.5,15.5 15.5,18.7 12,20.5 C8.5,18.7 5.5,15.5 5.5,11 V5.5 Z"/>
    <circle cx="12" cy="3" r="1.1" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-skill-technical" viewBox="0 0 24 24">
    <path d="M15.8,4.7 a4,4 0 0 0 -5.4,5.3 L5,15.4 a2.1,2.1 0 0 0 3,3 L13.4,13 a4,4 0 0 0 5.3,-5.4 l-2.9,2.9 -2.5,-2.5 Z"/>
    <circle cx="6.3" cy="17.7" r="1.1" fill="currentColor" stroke="none"/>
  </symbol>
  <symbol id="i-skill-general" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8.25"/>
    <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/>
  </symbol>
</defs>
`

export default function IconSprite() {
  return (
    <svg
      width="0"
      height="0"
      style={{ position: 'absolute' }}
      aria-hidden="true"
      focusable="false"
      dangerouslySetInnerHTML={{ __html: SPRITE_MARKUP }}
    />
  )
}
